module.exports = __webpack_public_path__ + "static/media/cam-help.cf3e9a33.png";